const groupByKey = (list, key) => {
  return list.reduce((grouped, item) => {
    const value = item[key]

    if (!grouped[value]) {
      grouped[value] = []
    }
    grouped[value].push(item)

    return grouped
  }, {})
}
const sortBy = (list, key, reverseOrder = false) => {
  const spin = reverseOrder ? -1 : 1

  return list.sort((a, b) => {
    if (a === null || b === null) {
      return 0
    }

    return a[key] > b[key] ? spin : -spin
  })
}
// inspired by lodash https://lodash.com/docs/#zipObject
const zipObject = (list) => {
  const data = list.length ? list : Object.values(list)

  return data.reduce((zipped, value, index) => {
    zipped[value] = index

    return zipped
  }, {})
}

const byKey = (list, key) => {
  return list.reduce((byKey, item) => {
    const value = item[key]

    byKey[value] = item

    return byKey
  }, {})
}

const addInListIfAbsent = (list, value) => {
  const index = list.indexOf(value)

  if (index < 0) {
    list.push(value)
  }
}

const removeFromListIfPresent = (list, value) => {
  const index = list.indexOf(value)

  if (index >= 0) {
    list.splice(index, 1)
  }
}

const addInObjListIfAbsent = (list, item) => {
  const index = list.findIndex((elem) => elem.id === item.id)

  if (index < 0) {
    list.push(item)
  } else {
    list[index] = item
  }
}

const removeFromObjListIfPresent = (list, item) => {
  const index = list.findIndex((elem) => elem.id === item.id)

  if (index >= 0) {
    list.splice(index, 1)
  }
}

const sortByNullAfter = (list, key) => {
  return list.sort((itemA, itemB) => {
    const a = key ? itemA[key] : itemA
    const b = key ? itemB[key] : itemB

    if (a === null && b === null) {
      return 0
    }
    if (a === null) {
      return 1
    }
    if (b === null) {
      return -1
    }

    return a > b ? 1 : -1
  })
}

const isEqual = (originalValue, currentValue) => {
  if (typeof currentValue === 'object') {
    return JSON.stringify(currentValue) === JSON.stringify(originalValue)
  }

  return currentValue === originalValue
}

const deepCopy = (originalValue) => {
  return JSON.parse(JSON.stringify(originalValue))
}

const camelize = (str) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase()
    })
    .replace(/\s+/g, '')
}

const uniqBy = (a, key) => {
  return [...new Map(a.map((x) => [key(x), x,])).values(),]
}

const compareObjectsValues = (originalPayload, modifiedPayload) => {
  return Object.values(modifiedPayload) === Object.values(originalPayload)
}

var compareObjects = (obj1, obj2) => {
  const keys = Object.keys(obj1)

  return keys.reduce((diff, key) => {
    if (!isEqual(obj1[key], obj2[key])) {
      diff[key] = obj2[key]
    }

    return diff
  }, {})
}

const removeAccessTokenFromUrl = () => {
  const { history, location, } = window
  const { search, } = location
  if (search && search.indexOf('jwt') !== -1 && history && history.replaceState) {
    // eslint-disable-next-line no-useless-escape
    const cleanSearch = search.replace(/(\&|\?)jwt([_A-Za-z0-9=\-\.%]+)/g, '').replace(/^&/, '?')
    const cleanURL = location.toString().replace(search, cleanSearch)
    history.replaceState({}, '', cleanURL)
  }
}
const chunk = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size), }, (v, i) => arr.slice(i * size, i * size + size))
}

const subsetObject = (fullObj, list) => {
  return list.reduce(function(o, k) {
    o[k] = fullObj[k]

    return o
  }, {})
}

const random = (prefix) => {
  const random = `${Math.random()}`.substr(3)

  return `${prefix}${random}`
}

export {
  camelize,
  groupByKey,
  zipObject,
  sortBy,
  byKey,
  addInListIfAbsent,
  removeFromListIfPresent,
  addInObjListIfAbsent,
  removeFromObjListIfPresent,
  sortByNullAfter,
  compareObjectsValues,
  compareObjects,
  isEqual,
  deepCopy,
  uniqBy,
  removeAccessTokenFromUrl,
  chunk,
  subsetObject,
  random,
}
